<cw-ci-data-table #assessmentDataTable
  tileTitle="Certifications"
  refreshToolTip="Reload certification list"
  defaultSortField="updatedAt"
  defaultSortDirection="desc"
  [isSelectable]="isSelectable"
  (loadItemsHandler)="loadAssessments($event)"
  (selectHandler)="selectAssessment($event)"
  [items]="assessmentList">

  <!-- Not necessary to display the company name for the initial release since certifications are only for the master account. -->
  <!-- <cw-ci-table-column columnName="accountName" columnTitle="Company" sortField="account_name" searchField="account_name" filterType="text" [output]="nameTemplate"></cw-ci-table-column>
  <ng-template let-element #nameTemplate>
    {{element.accountName}}
    <ng-container *ngIf="element.parentId == undefined">
      <br><span class="text-accent" style="font-style:italic">Primary Account</span>
    </ng-container>
  </ng-template> -->

  <cw-ci-table-column columnName="assessmentName" columnTitle="Name"></cw-ci-table-column>

  <cw-ci-table-column columnName="percentComplete" columnTitle="Assessment Progress" sortField="percentComplete" [output]="percentCompleteTemplate"></cw-ci-table-column>
  <ng-template let-element #percentCompleteTemplate>
    <div class="custom-progress-bar" [ngClass]="{'progress-not-started':element.percentComplete==0}" style="width:200px">
      <div *ngIf="element.percentComplete>0" class="bg-primary" [ngStyle]="{'width': element.percentCompleteStr}">{{element.percentCompleteStr}}</div>
      <div *ngIf="element.percentComplete==0" class="bg-warn">{{element.percentComplete}}</div>
    </div>
  </ng-template>

  <cw-ci-table-column columnName="updatedAt" columnTitle="Assessment Updated" sortField="updatedAt" [output]="updatedTemplate"></cw-ci-table-column>
  <ng-template let-element #updatedTemplate>{{element.updatedAt | date:'short'}}</ng-template>

  <cw-ci-table-column columnName="actions" columnTitle="Actions" [output]="actionTemplate"></cw-ci-table-column>
  <ng-template let-element #actionTemplate>
    <cw-ci-table-column-action [visible]="element.status === 'COMPLETED'" actionToolTip="View the assessment results" svgIcon="cw:action_toggle_graph" actionColor="primary" [element]="element" (clickHandler)="selectAssessment($event)"></cw-ci-table-column-action>
    <cw-ci-table-column-action [visible]="element.status !== 'COMPLETED'" actionToolTip="Work on the assessment" svgIcon="cw:application_appcues" actionColor="primary" [element]="element" (clickHandler)="selectAssessment($event)"></cw-ci-table-column-action>
  </ng-template>
</cw-ci-data-table>
